import { Row, Col } from 'react-bootstrap';
import SVGGauge from './SVGGauge';
import { StrategyOptions } from '../../models';
import { useLocaleContext } from '../../i18n';

interface Props {
  totalCarbs: number;
  totalConsumedKcal: number;
  totalBalance: number;
  avgCarbsPerHour: number;
  strategyOptions: StrategyOptions;
  totalDuration: string;
}

export default function FuelStats({ totalCarbs, totalConsumedKcal, totalBalance, avgCarbsPerHour, strategyOptions, totalDuration }: Props) {
  const { locale } = useLocaleContext();
  const totalBurnedKcal = totalConsumedKcal - totalBalance;

  const durationMatch = totalDuration.match(/PT(?:(\d+)H)?(?:(\d+)M)?/);
  const hours = parseInt(durationMatch?.[1] ?? '0');
  const minutes = parseInt(durationMatch?.[2] ?? '0');
  const totalHours = hours + minutes / 60 || 1;

  const maxAbsorptionTotal = strategyOptions.maxAbsorptionRatePerHour * totalHours;
  const carbsPercent = Math.min(1, totalCarbs / maxAbsorptionTotal);
  const avgPercent = Math.min(1, avgCarbsPerHour / strategyOptions.maxAbsorptionRatePerHour);
  const balancePercent = Math.min(1, totalConsumedKcal / totalBurnedKcal);

  const carbsSecondary = `max ${Math.round(maxAbsorptionTotal)}g`;
  const balanceSecondary = `${totalBurnedKcal}kcal ${locale.planner.stats.burned}`;
  const avgSecondary = `max ${strategyOptions.maxAbsorptionRatePerHour}g/h`;

  return (
    <Row className="text-center g-3">
      <Col md={4}>
        <div style={{ transform: 'scale(0.85)', transformOrigin: 'top center' }}>
          <SVGGauge
            percent={carbsPercent}
            value={`${totalCarbs} g`}
            label={locale.planner.stats.carbs}
            fromColor="#0d6efd"
            toColor="#ffc107"
            secondaryInfo={carbsSecondary}
          />
        </div>
      </Col>
      <Col md={4}>
        <div style={{ transform: 'scale(0.85)', transformOrigin: 'top center' }}>
          <SVGGauge
            percent={balancePercent}
            value={`${totalBalance > 0 ? '+' : ''}${totalBalance} kcal`}
            label={locale.planner.stats.balance}
            fromColor="#0d6efd"
            toColor="#28a745"
            secondaryInfo={balanceSecondary}
          />
        </div>
      </Col>
      <Col md={4}>
        <div style={{ transform: 'scale(0.85)', transformOrigin: 'top center' }}>
          <SVGGauge
            percent={avgPercent}
            value={`${avgCarbsPerHour} g/h`}
            label={locale.planner.stats.average}
            fromColor="#0d6efd"
            toColor="#28a745"
            secondaryInfo={avgSecondary}
          />
        </div>
      </Col>
    </Row>
  );
}
